window.bootstrap = require('bootstrap');
import { Helpers } from "@HELPERS/helpers";
import MicroModal from 'micromodal';
import tippy from 'tippy.js';

export namespace Main {
	const mdBreakpoint = '1200px';

	let initializeCollapsableTables = () => {
		let expandableTables = document.querySelectorAll('.table-expandable');

		//DONT RUN THIS FUNCTION IF WE DONT HAVE EXPANDABLE TABLES
		if(!expandableTables.length) {
			return;
		}

		//create icons that are for each expandable row
		let createExpandableRowTriggers = (row) => {
			//The td we will append our trigger arrows to
			let firstTD = row.querySelector('td:first-child');

			//Create the trigger that will expand the rows with matching row ids
			const aTag = document.createElement("a");
			const icon = document.createElement("span");
			aTag.classList.add('js-row-trigger');
			aTag.classList.add('table-trigger');
			icon.classList.add('icon-angle-down');
			aTag.setAttribute('href', '#');
			aTag.appendChild(icon);

			// add the icon to the first td in the Table
			firstTD.appendChild(aTag);

			return aTag;
		}

		expandableTables.forEach((table) => {

			let toggleRows = table.querySelectorAll('tr[data-toggle-row-id]');

			toggleRows.forEach((row) => {
				//grab the identifier for the rows to show
				let rowID = row.getAttribute('data-toggle-row-id');

				//add our Icons and return back the a tag
				let aTag = createExpandableRowTriggers(row);

				//setup the click event on the trigger - toggle show and hide
				aTag.addEventListener('click', (event) => {
					event.preventDefault();
					let expandableRows = table.querySelectorAll(`tr[data-row-id="${rowID}"]`);
					let lastRow = expandableRows[expandableRows.length- 1];
					lastRow.classList.add('last-row-in-series');

					if(expandableRows.length) {
						expandableRows.forEach((expandableRow) => {
							if(expandableRow.classList.contains('state-row-expanded')) {
								row.classList.remove('state-parent-row-expanded');
								expandableRow.classList.remove('state-row-expanded');
							} else {
								row.classList.add('state-parent-row-expanded');
								expandableRow.classList.add('state-row-expanded');
							}
						});
					}
				});
			});
		});
	};

	let setupAccordions = () => {
		let accordionTriggers = document.querySelectorAll<HTMLElement>('.js-acc-trigger');
		accordionTriggers.forEach((trigger) => {
			trigger.addEventListener('click', (event) => {
				let parent = trigger.parentElement;

				if(parent.classList.contains("state-open")) {
					parent.classList.remove("state-open");
				} else {
					parent.classList.add('state-open');
				}

				event.preventDefault();
			});
		});
	}

	let dataTables = () => {
		function mobileTables() {
			// Find all the data tables on the page
			let tables = document.getElementsByClassName('js-data-table');

			// Loop through all the tables
			for (let i = 0; i < tables.length; i++) {
				let currentTable = tables[i];
				let tableHead = currentTable.getElementsByTagName('thead');
				if (!tableHead.length) { continue };
				let headCells = tableHead[0].getElementsByTagName('th');
				let tableBody = currentTable.getElementsByTagName('tbody');
				if (!tableBody.length) { continue };
				let bodyRows = tableBody[0].getElementsByTagName('tr');

				horizontalScroll(currentTable);
				addSpinner();

				// Loop through the rows of the table body
				for (let j = 0; j < bodyRows.length; j++) {
					let bodyCells = bodyRows[j].getElementsByTagName('td');

					// Loop through the cells of the row
					for (let t = 0; t < bodyCells.length; t++) {
						let label = '';

						// If the column label does not contain the class .no-mobile get the cell label by
						// counting which column this cell is in, counting that far in to the table head columns,
						// and getting the innerHTML
						if (headCells.length) {
							if (!headCells[t].classList.contains('no-mobile')) {
								label = headCells[t].innerHTML;
							} else {
								label = "null";
							}

							// If the viewport is less than or equal to the 767.98px...
							if (window.matchMedia(`(max-width: ${mdBreakpoint})`).matches) {
								addMobileLabels(t, bodyCells, label);
							} else {
								removeMobileLabel(t, bodyCells);
							}
						}
					}
				}
			}
		}

		// Adds and removes a class that allows the table to scroll horizontally when the table is wider than it's container
		function horizontalScroll(currentTable) {
			let tableContainer = currentTable.parentElement;
			let containerWidth = tableContainer.offsetWidth;
			let tableWidth = (currentTable as HTMLElement).offsetWidth;

			// If the table width is larger than the container width..
			if (tableWidth > containerWidth && !tableContainer.classList.contains('data-table--responsive')) {
				tableContainer.classList.add('data-table--responsive');
				// Otherwise if the table width is equal to or less than the container width...
			} else if (tableWidth <= containerWidth && tableContainer.classList.contains('data-table--responsive')) {
				tableContainer.classList.remove('data-table--responsive');
			}
		}

		// Adds column headers to cells for mobile
		function addMobileLabels(t, bodyCells, label) {
			// If the cell does not already contain a span...
			if (!bodyCells[t].innerHTML.includes('js-mobile-label') && label != "null") {
				bodyCells[t].innerHTML = '<span class="js-mobile-label">' + label + '</span>' + bodyCells[t].innerHTML;
			}
		}

		// Removes column headers from cells for screen sizes other than mobile
		function removeMobileLabel(t, bodyCells) {
			// If the cell already contains a span...
			if (bodyCells[t].innerHTML.includes('js-mobile-label')) {
				bodyCells[t].removeChild(bodyCells[t].getElementsByClassName('js-mobile-label')[0]);
			}
		}

		// Adds a loading spinner on click of the filter button
		function addSpinner() {
			let filterButtons = document.querySelectorAll('.js-filter-submit');

			if (filterButtons) {
				for (let i = 0; i < filterButtons.length; i++) {
					filterButtons[i].addEventListener('click', function () {
						filterButtons[i].classList.add('loading');
					})
				}
			}
		}

		// Run function on page load
		mobileTables();

		// Run function on orientation change
		screen.orientation.onchange = function () {
			mobileTables();
		}

		// Run function on window resize
		window.addEventListener('resize', function () {
			mobileTables();
		});
	};

	/**
	* Sets up the pagination control for data tables
	*/
	let paginationSetup = () => {
		let form: HTMLFormElement = document.querySelector('.js-form-actions form');
		let page: any = document.getElementById('Criteria_Page');

		// handle pagination
		document.querySelectorAll('.pagination-container a').forEach(function (el) {
			el.addEventListener('click', function (e) {
				e.preventDefault();

				// Set current page number and submit form
				let target = e.target as HTMLAnchorElement;
				page.value = target.getAttribute('href');
				form.submit();
			});
		});
	};

	let tableFilters = () => {
		let tableFilters = document.getElementById('js-table-filters');

		if (tableFilters) {
			let filters = tableFilters.querySelectorAll('.form-group');
			let filterCount = filters.length;

			if (filterCount <= 8) {
				let className = 'data-table__inputs--' + filterCount;

				tableFilters.classList.add(className);
			} else {
				tableFilters.classList.add('data-table__inputs--overloaded');
			}
		}
	}

	let initializeModals = () => {
		MicroModal.init();
	};

	let setupJumpNav = () => {
		let mobileTriggers = document.querySelectorAll('.js-jump-nav-trigger');
		let jumpNavLinks = document.querySelectorAll('.jump-nav__link');

		mobileTriggers.forEach((mobileTrigger) => {
			mobileTrigger.addEventListener('click', (event) => {
				let parentEl = mobileTrigger.closest('.jump-nav');
				event.preventDefault();
				if(parentEl.classList.contains('state-open')) {
					parentEl.classList.remove('state-open');
				} else {
					parentEl.classList.add('state-open');
				}

				Helpers.CloseOnOutsideClick(parentEl, () => {
					parentEl.classList.remove('state-open');
				});
			})
		});

		jumpNavLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				let parentEl = link.closest('.jump-nav');
				parentEl.classList.remove('state-open');
			});
		});

	};

	let tooltipsSetup = () => {
		let toolTips = document.querySelectorAll('.js-tooltip');
		let advancedTooltips = document.querySelectorAll('.js-tooltip-advanced');

		//if we dont have any tooltips on the page abandon this function and dont run the rest
		if(!toolTips.length || !advancedTooltips.length) {
			return;
		}

		//simple html
		if(toolTips.length) {
			toolTips.forEach(tooltip => {
				tippy(tooltip, {
					content: tooltip.getAttribute('data-tooltip-content'),
					allowHTML: true,
					touch: false
				});
			});
		}

		//more advanced html
		if(advancedTooltips.length) {
			advancedTooltips.forEach(advancedTooltip => {
				const template = advancedTooltip.querySelector('.tooltip-content');
				tippy(advancedTooltip, {
					content: template.innerHTML,
					allowHTML: true,
					touch: false
				});
			});
		}
	}

	let setupMainNavigation = () => {
		let navTrigger = document.querySelector('.js-mobile-trigger');
		let body = document.body;

        if (navTrigger != null){
            navTrigger.addEventListener('click', () => {
                let parentEl = navTrigger.parentElement;

                if(parentEl.classList.contains('state-nav-open')) {
                    parentEl.classList.remove('state-nav-open');
                    body.classList.remove('state-fixed');
                } else {
                    parentEl.classList.add('state-nav-open');
                    body.classList.add('state-fixed');
                }
            });
        }
	}

	/**
	 * Container Initialization
	 */
	export const init = () => {
		dataTables();
		initializeCollapsableTables();
		initializeModals();
		setupAccordions();
		setupJumpNav();
		tooltipsSetup();
		setupMainNavigation();
		tableFilters();
		paginationSetup();
	};
}

document.addEventListener("DOMContentLoaded", () => {
    Main.init();
});